export const getFileExtFromUrl = (url) => {
  const lastIndexOfPeriod = url.lastIndexOf('.');
  const fileType = url.slice(lastIndexOfPeriod + 1);
  return fileType;
};

export const formatFileSize = (size) => parseInt(size).toFixed(0);
